function isAttachment(object) {
    return "name" in object;
}

var FX_RATE_CURRENCIES = [
    "AFN",
    "ALL",
    "DZD",
    "AOA",
    "ARS",
    "AMD",
    "AWG",
    "AUD",
    "AZN",
    "BSD",
    "BHD",
    "BDT",
    "BBD",
    "BYN",
    "BZD",
    "BMD",
    "BTN",
    "BOB",
    "BAM",
    "BWP",
    "BRL",
    "BND",
    "BGN",
    "BIF",
    "KHR",
    "CAD",
    "KYD",
    "CLF",
    "CLP",
    "CNY",
    "COP",
    "XOF",
    "XAF",
    "KMF",
    "XPF",
    "CDF",
    "CRC",
    "HRK",
    "CUP",
    "CZK",
    "DKK",
    "DJF",
    "DOP",
    "XCD",
    "ECS",
    "EGP",
    "SVC",
    "ERN",
    "ETB",
    "EUR",
    "FKP",
    "FJD",
    "GMD",
    "GEL",
    "GHS",
    "GIP",
    "GTQ",
    "GNF",
    "GYD",
    "HTG",
    "HNL",
    "HKD",
    "HUF",
    "ISK",
    "INR",
    "IDR",
    "XDR",
    "IRR",
    "IQD",
    "ILS",
    "JMD",
    "JPY",
    "JOD",
    "KZT",
    "KES",
    "KRW",
    "KWD",
    "KGS",
    "LAK",
    "LVL",
    "LBP",
    "LSL",
    "LRD",
    "LYD",
    "LTL",
    "MOP",
    "MKD",
    "MGA",
    "MWK",
    "MYR",
    "MVR",
    "MUR",
    "MXN",
    "MDL",
    "MNT",
    "MAD",
    "MZN",
    "MMK",
    "NAD",
    "NPR",
    "ANG",
    "NZD",
    "NIO",
    "NGN",
    "NOK",
    "OMR",
    "PKR",
    "PAB",
    "PGK",
    "PYG",
    "PEN",
    "PHP",
    "PLN",
    "QAR",
    "RON",
    "ROL",
    "RUB",
    "RWF",
    "SHP",
    "WST",
    "SAR",
    "RSD",
    "SCR",
    "SLL",
    "SGD",
    "SBD",
    "SOS",
    "ZAR",
    "LKR",
    "SDG",
    "SRD",
    "SZL",
    "SEK",
    "CHF",
    "SYP",
    "TWD",
    "TZS",
    "THB",
    "TOP",
    "TTD",
    "TND",
    "TRY",
    "TMT",
    "UGX",
    "UAH",
    "AED",
    "GBP",
    "USD",
    "XCG",
    "UYU",
    "UZS",
    "VUV",
    "VES",
    "VND",
    "YER",
    "ZMW",
    "CVE",
    "TOF",
];

var INITIATIVE_PHASES = [
    "L0 - Idea",
    "L1 - Identified",
    "L2 - Validated",
    "L3 - Execution Prep",
    "L4 - Execution",
    "L5 - Fully Realized",
];
var FUNCTION_TYPES = [
    "Finance",
    "HR",
    "Audit",
    "L&C",
    "Other Central Function",
    "Operations Support",
    "Real Estate Management",
    "Organizational Management",
    "IT",
    "Provider and Network Management",
    "Technical Cost Center",
    "Market Management",
    "Product Provider",
    "Underwriting & Policy Management",
    "Sales & Distribution",
    "Commissions",
    "Claims",
    "ALAE",
    "Other",
];
var LINES_OF_BUSINESS = [
    "P&C Motor",
    "P&C Non-Motor",
    "Life",
    "Health",
    "Commercial",
    "Other",
];
var EXTENDED_LINES_OF_BUSINESS = [
    "Mobility & Assistance",
    "EL & MDDR",
    "EL",
    "MDDR",
    "Home",
    "Medical OPS",
    "Transversal",
    "Travel",
    "Central Functions",
    "Automotive",
];
var COMMERCIAL_LINES_OF_BUSINESS = [
    "All",
    "Financial Lines & Cyber",
    "Property",
    "Liability",
    "Specialty Lines",
    "Allianz Risk Transfer",
    "N/A",
];
var PRIMARY_IMPACT_DRIVERS = [
    "Quantitative",
    "Qualitative",
    "Growth",
];
var IMPACT_SERIES = [
    "tieServiceExpensesImpact",
    "indemnityImpact",
    "toplineImpact",
    "commissionsImpact",
    "internalFteImpact",
    "externalFteImpact",
    "investment",
];
var IMPACT_SERIES_KEYS = [
    "tieServiceExpensesImpactPlanned",
    "tieServiceExpensesImpactActual",
    "indemnityImpactPlanned",
    "indemnityImpactActual",
    "toplineImpactPlanned",
    "toplineImpactActual",
    "commissionsImpactPlanned",
    "commissionsImpactActual",
    "internalFteImpactPlanned",
    "internalFteImpactActual",
    "externalFteImpactPlanned",
    "externalFteImpactActual",
    "investmentPlanned",
    "investmentActual",
    "hrCostImpactPlanned",
    "hrCostImpactActual",
];
var QUALITATIVE_IMPACT_TYPES = [
    "Customer Satisfaction",
    "Employee Engagement Quality",
    "Compliance/Legal",
    "Resiliance",
    "Other",
];
var IMPLEMENTATION_PROGRAM_TYPES = [
    "ACM",
    "Beat the Best",
    "ITMP/BMP",
    "Rapid Productivity",
    "Other",
];
var CATEGORY_TYPES = [
    "Global Sourcing",
    "OPS Excellence",
    "Process Automation",
    "Speedboat",
    "WFM",
];
var INITIATIVE_ENABLER_TYPES = [
    "Process Mining",
    "Automation",
];
var AUTOMATION_UNDERLYING_PLATFORM_TYPES = [
    "Group Solution",
    "Local Solution",
    "Legacy System (to be decommissioned)",
    "N/A",
];
var AUTOMATION_COMPLEXITY_TYPES = ["Low", "Medium", "High"];
var AUTOMATION_SOLUTION_IMPLEMENTATION_PROVIDER_TYPE = [
    "OE Internal",
    "AZ Services",
    "AZ Technology",
    "Third Party",
];
var AUTOMATION_METHODOLOGY_TYPE = [
    "RPA - Robotics Process Automation",
    "Workflow Automation / Rule based decision",
    "Chatbot",
    "Voicebot",
    "Intelligent Document Processing / Intelligent Document Management",
    "Agent Assist",
    "Other",
];
var PROCESS_MINING_ENABLEMENT_TYPE = [
    "Identification",
    "Monitoring",
    "Direct (e.g. Action Flows)",
    "Other",
];
var INTER_OE_REGION_TYPE = [
    "All",
    "Europe",
    "APAC",
    "North America",
    "Latin America",
    "Western Europe",
    "Central & Eastern Europe",
    "Southern Europe",
    "Nordics",
];
var BUSINESS_UNIT_TYPE = [
    "Allianz Care",
    "BU Australia",
    "BU Austria",
    "Austria - GCC Romania",
    "BU Belgium",
    "Belgium - MGCC",
    "BU Brazil",
    "BU Canada",
    "BU China",
    "BU Colombia",
    "BU Czech Republic",
    "BU France",
    "BU Germany",
    "Germany - AHS",
    "BU Greece",
    "BU GTS",
    "BU Hong Kong",
    "BU India",
    "India - GCC",
    "BU Indonesia",
    "BU Ireland",
    "BU Italy",
    "BU Japan",
    "BU Malaysia",
    "BU Mexico",
    "Mexico - GCC",
    "BU Netherlands",
    "BU New Zealand",
    "BU Poland",
    "BU Portugal",
    "BU Reunion",
    "BU Russia",
    "BU Singapore",
    "BU Spain",
    "BU Switzerland",
    "BU Thailand",
    "Thailand - GCC",
    "BU Turkey",
    "BU United Kingdom",
    "BU United States",
    "FOS",
    "Global Office",
    "Medi24",
    "MultiAsistencia",
    "Nextcare",
    "Warranty GMBH",
    "GSP Business",
];
function isMontlyImpactMap(impact) {
    return Array.isArray(impact);
}

export { AUTOMATION_COMPLEXITY_TYPES, AUTOMATION_METHODOLOGY_TYPE, AUTOMATION_SOLUTION_IMPLEMENTATION_PROVIDER_TYPE, AUTOMATION_UNDERLYING_PLATFORM_TYPES, BUSINESS_UNIT_TYPE, CATEGORY_TYPES, COMMERCIAL_LINES_OF_BUSINESS, EXTENDED_LINES_OF_BUSINESS, FUNCTION_TYPES, FX_RATE_CURRENCIES, IMPACT_SERIES, IMPACT_SERIES_KEYS, IMPLEMENTATION_PROGRAM_TYPES, INITIATIVE_ENABLER_TYPES, INITIATIVE_PHASES, INTER_OE_REGION_TYPE, LINES_OF_BUSINESS, PRIMARY_IMPACT_DRIVERS, PROCESS_MINING_ENABLEMENT_TYPE, QUALITATIVE_IMPACT_TYPES, isAttachment, isMontlyImpactMap };
